<template>
  <b-row align-h="center" v-if="dataLoading">
    <b-spinner
      class="mt-4"
      style="width: 4rem; height: 4rem"
      type="grow"
      variant="primary"
      label="Spinning"
    ></b-spinner>
  </b-row>
  <div v-else>
    <!-- <b-row class="mb-1">
      <b-col>
        <b-button variant="outline-secondary" @click="$router.go(-1)">
          <feather-icon class="" icon="ArrowLeftIcon" />
          Back
        </b-button>
      </b-col>
    </b-row> -->
    <b-card>
      <b-row>
        <b-col xl="2" lg="2" md="6" class="d-flex align-items-center">
          <b-button
            variant="outline-secondary"
            @click="$router.go(-1)"
            class="mr-1"
          >
            <feather-icon class="" icon="ArrowLeftIcon" />
            Back
          </b-button>
        </b-col>
        <b-col xl="3" lg="3" md="6">
          <b-form-group
            label="Class"
            :invalid-feedback="$t('Class is required')"
            ref="class"
          >
            <v-select
              v-model="myObj.clsID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="classes"
              :clearable="false"
              label="name"
              :reduce="(val) => val.id"
              ref="class"
              :disabled="$route.params.id > 0"
              placeholder="Select class"
              @input="FillSections()"
            />
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" md="6">
          <b-form-group
            label="Section"
            invalid-feedback="Section is required"
            ref="sec"
          >
            <v-select
              ref="sec"
              v-model="secIDs"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="currentSections"
              :reduce="(val) => val.id"
              label="section"
              :clearable="false"
              :disabled="$route.params.id > 0"
              placeholder="Select section"
            />
          </b-form-group>
        </b-col>
        <b-col xl="4" lg="4" md="6">
          <b-form-group
            label="Subject"
            invalid-feedback="Subject is required"
            ref="syll_sub"
          >
            <v-select
              ref="syll_sub"
              v-model="myObj.subjectID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="subjects"
              :clearable="false"
              label="subject"
              :reduce="(val) => val.id"
              placeholder="Select subject"
              :disabled="$route.params.id > 0"
              @input="checkData()"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-row align-h="center" v-if="otherLoading">
      <b-spinner
        class="mt-4"
        style="width: 4rem; height: 4rem"
        type="grow"
        variant="primary"
        label="Spinning"
      ></b-spinner>
    </b-row>
    <div v-else>
      <template v-for="(item, ind) in plannerData">
        <b-card class="">
          <b-row>
            <b-col xl="2" lg="2" md="3" sm="4">
              <b-form-group
                label="Date"
                invalid-feedback="Date is required"
                ref="date"
                class="mr-50"
              >
                <flat-pickr
                  :config="config"
                  v-model="item.data.range"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  @on-change="setDate(item.data)"
                  @on-open="setDisable(ind)"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="3" sm="4">
              <b-form-group
                label="Topic"
                invalid-feedback="Topic is required"
                :ref="'topic_dd' + ind"
              >
                <v-select
                  v-model="item.data.topicID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="topics"
                  :reduce="(val) => val.id"
                  label="name"
                  :clearable="false"
                  placeholder="Select topic"
                  @input="fillSubtopics(item.data)"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="3" sm="4">
              <b-form-group
                label="Subtopic"
                invalid-feedback="Subtopic is required"
                :ref="'subtopic' + ind"
              >
                <v-select
                  v-model="item.data.subtopicID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="item.data.subtopics || []"
                  :reduce="(val) => val.id"
                  label="name"
                  :clearable="false"
                  placeholder="Select subtopic"
                />
              </b-form-group>
            </b-col>
            <b-col xl="2" lg="2" md="2" sm="4">
              <b-form-group
                label="Duration (mins)"
                invalid-feedback="Duration is required"
                :ref="'duration' + ind"
              >
                <b-form-input
                  placeholder="Duration"
                  v-model="item.data.duration"
                />
              </b-form-group>
            </b-col>
            <b-col xl="2" lg="2" md="1" sm="12" class="d-flex align-items-end">
              <div
                class="d-flex align-items-center justify-content-end w-100 pb-50"
              >
                <feather-icon
                  size="25"
                  :icon="
                    collapseData[ind].state ? 'ArrowUpIcon' : 'ArrowDownIcon'
                  "
                  @click="toggleCard(ind)"
                  class="cursor-pointer"
                />
              </div>
            </b-col>
          </b-row>
          <b-collapse :id="`collapse-${ind}`" v-model="collapseData[ind].state">
            <b-row>
              <b-col md="12" class="mb-1">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="addDetailEntry(item, ind)"
                >
                  <feather-icon size="14" icon="PlusIcon" />
                  <span>Add Detail Entry</span>
                </b-button>
              </b-col>
            </b-row>
            <template v-for="(detail, detailInd) in item.details">
              <b-card class="mt-1 border-secondary">
                <b-row>
                  <b-col
                    md="12"
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <h6 class="mb-0">Detail Entry {{ detailInd + 1 }}</h6>
                    <b-button
                      v-if="item.details.length > 1"
                      variant="outline-danger"
                      size="sm"
                      @click="removeDetailEntry(item, detailInd)"
                      class="btn-icon"
                    >
                      <feather-icon size="14" icon="XIcon" />
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="6" lg="6" md="6">
                    <b-form-group
                      label="Materials Required (optional)"
                      invalid-feedback="Materials is required."
                    >
                      <quill-editor
                        v-model="detail.materials"
                        :options="{
                          modules: {
                            toolbar: editorOptions,
                          },
                          placeholder: 'enter materials',
                        }"
                      >
                      </quill-editor>
                    </b-form-group>
                  </b-col>
                  <b-col xl="6" lg="6" md="6">
                    <b-form-group
                      label="Objectives (optional)"
                      invalid-feedback="Objectives is required."
                    >
                      <quill-editor
                        v-model="detail.objectives"
                        :options="{
                          modules: {
                            toolbar: editorOptions,
                          },
                          placeholder: 'enter objectives',
                        }"
                      >
                      </quill-editor>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="12" lg="12" md="12">
                    <b-form-group
                      label="Lesson"
                      invalid-feedback="Lesson is required."
                    >
                      <quill-editor
                        v-model="detail.lesson"
                        :options="{
                          modules: {
                            toolbar: editorOptions,
                          },
                          placeholder: 'enter lesson',
                        }"
                      >
                      </quill-editor>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="12" lg="12" md="12">
                    <b-form-group
                      label="Remarks (optional)"
                      invalid-feedback="Remarks is required."
                    >
                      <b-form-textarea
                        placeholder="Enter remarks"
                        v-model="detail.remarks"
                        rows="2"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </template>
          </b-collapse>
        </b-card>
        <b-row class="mb-1">
          <b-col md="12" class="text-center">
            <b-button
              v-if="ind == plannerData.length - 1"
              @click="AddPlannerEntry()"
              variant="primary"
              class="btn-icon"
            >
              <feather-icon size="16" icon="PlusIcon" />
              <span>Add More Planning Entry</span>
            </b-button>
            <b-button
              v-else
              @click="removePlannerEntry(ind)"
              variant="outline-danger"
              class="btn-icon"
            >
              <feather-icon size="16" icon="XIcon" />
              <span>Remove Planning Entry</span>
            </b-button>
          </b-col>
        </b-row>
      </template>

      <b-row align-h="center" class="mt-2">
        <b-col md="6">
          <b-button block variant="success" :disabled="request" @click="save()">
            <b-spinner v-if="request" small type="grow" />
            <span v-else>Save </span>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import { quillEditor } from "vue-quill-editor";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BFormTextarea,
  BInputGroup,
  BCollapse,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import store from "@/store";
import { avatarText } from "@core/utils/filter";
import flatPickr from "vue-flatpickr-component";
import { BFormSelect } from "bootstrap-vue";
//import Multiselect from "vue-multiselect";
import VueGallery from "vue-gallery";
import { forEach } from "postcss-rtl/lib/affected-props";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  components: {
    quillEditor,
    flatPickr,
    BFormTextarea,
    BImg,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BCollapse,
    vSelect,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    let right = this.$store.state.rights["manage-planner"];
    if (!right) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      if (this.$route.params.id > 0 && right.edit) {
        this.myObj = {
          id: this.$route.params.id,
          clsID: 0,
          secID: 0,
          subjectID: 0,
          tID: 0,
          campusID: this.$store.state.userData.cId,
        };
        this.secIDs = 0;
        await this.LoadInitialData();
        await this.LoadData();
      } else if (this.$route.params.id == 0 && right.add) {
        this.myObj = {
          id: 0,
          clsID: 0,
          secID: 0,
          subjectID: 0,
          tID: 0,
          campusID: this.$store.state.userData.cId,
        };
        this.secIDs = 0;
        await this.LoadInitialData();
      } else {
        this.$router.replace({
          name: "misc-not-authorized",
        });
      }
      console.log(this.collapseData);
    }
  },
  computed: {
    ...mapGetters({ cmbDepartment: "cmbDepartment" }),
    ...mapGetters({ data: "data" }),

    filters: function () {
      return this.items.filter((pro) => {
        return pro.subject.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
  },
  data() {
    return {
      editorOptions: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote"],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction

        [{ size: ["small", false, "large", "huge"] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme

        [{ align: [] }],
        ["link"],
      ],
      collapseData: [],
      isOther: false,
      rights: {},
      request: false,
      dataLoading: false,
      otherLoading: "",

      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
        disable: [],
      },

      classes: [],
      allClassesData: [],
      currentSections: [],
      subjects: [],
      topics: [],
      secIDs: [],
      myObj: {
        clsID: 0,
        secID: 0,
        subjectID: 0,
        tID: 0,
        campusID: this.$store.state.userData.cId,
      },

      plannerData: [],
      topics: [],
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    toggleCard(ind) {
      // this.$root.$emit("bv::toggle::collapse", `collapse-${i}`);
      this.collapseData[ind].state = !this.collapseData[ind].state;
    },

    setDate(data) {
      // console.log(data.range);
      let d = data.range.split(" to ");
      if (d.length == 1) {
        data.dateFrom = d[0];
        data.dateTo = d[0];
      } else {
        data.dateFrom = d[0];
        data.dateTo = d[1];
      }
      // Update all details with the same date range
      let parentItem = this.plannerData.find((item) => item.data === data);
      if (parentItem) {
        parentItem.details.forEach((detail) => {
          detail.dateFrom = data.dateFrom;
          detail.dateTo = data.dateTo;
        });
      }
    },
    setDisable(ind) {
      this.config.disable = [];
      this.plannerData.forEach((el, i) => {
        if (ind != i && el.data.dateFrom && el.data.dateTo) {
          this.config.disable.push({
            from: el.data.dateFrom,
            to: el.data.dateTo,
          });
        }
      });
    },

    FillSections(text) {
      this.currentSections = [];

      if (this.myObj.clsID > 0) {
        const selectedClass = this.allClassesData.find(
          (el) => el.cls.id === this.myObj.clsID
        );
        if (
          selectedClass &&
          selectedClass.sections &&
          selectedClass.sections.length > 0
        ) {
          this.currentSections = selectedClass.sections;
        }
      }

      if (text !== "filled") {
        this.secIDs = 0;
        this.myObj.subjectID = 0;
      }
    },

    async loadSubjects() {
      let obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjects = await this.get(obj);
    },

    async checkData() {
      this.otherLoading = true;
      let obj = {
        url:
          this.$store.state.domain +
          "PlannerData/LoadData?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&gridID=0" +
          "&clsID=" +
          this.myObj.clsID +
          "&secID=" +
          this.secIDs +
          "&subID=" +
          this.myObj.subjectID,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      if (res.length > 0) {
        // Transform existing data to new structure
        this.convertToPlannerData(res);
        this.myObj.id = res[0].plannerGridID;
      } else {
        // Load topics for new planner
        // await this.loadTopics();
        this.AddPlannerEntry();
      }

      this.otherLoading = false;
    },

    async loadTopics() {
      let obj = {
        url:
          this.$store.state.domain +
          "Topics/GetBySubject?db=" +
          this.$store.state.userData.db +
          "&subjectID=" +
          this.myObj.subjectID,
        token: this.$store.state.userData.token,
      };
      this.topics = await this.get(obj);
    },

    convertToPlannerData(data) {
      // Convert old syllabus data to new planner structure
      this.plannerData = [];
      this.collapseData = [];

      data.forEach((item, index) => {
        this.plannerData.push({
          data: {
            id: item.id,
            plannerGridID: item.plannerGridID,
            topicID: item.topicID || 0,
            subtopicID: item.subtopicID || 0,
            duration: item.duration || 0,
            dateFrom: item.dateFrom,
            dateTo: item.dateTo,
            range: `${item.dateFrom} to ${item.dateTo}`,
            subtopics: [],
            campusID: item.campusID,
          },
          details: [
            {
              id: item.id,
              plannerGridID: item.plannerGridID,
              topicID: item.topicID || 0,
              subtopicID: item.subtopicID || 0,
              duration: item.duration || 0,
              dateFrom: item.dateFrom,
              dateTo: item.dateTo,
              topic: item.topic || "",
              materials: item.materials || "",
              objectives: item.objectives || "",
              lesson: item.lesson || "",
              remarks: item.remarks || "",
              campusID: item.campusID,
            },
          ],
        });
        this.collapseData.push({ state: false });
      });
    },

    checkCls() {
      var elem = this.$refs["class"];
      if (this.myObj.clsID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkSec() {
      var elem = this.$refs["sec"];
      if (this.secIDs == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkSubject() {
      var elem = this.$refs["syll_sub"];
      if (this.myObj.subjectID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    CheckValues() {
      let state = true;
      this.plannerData.forEach((item) => {
        // Check data fields
        if (
          !item.data.dateFrom ||
          !item.data.dateTo ||
          item.data.topicID == 0 ||
          item.data.subtopicID == 0 ||
          item.data.duration <= 0
        ) {
          state = false;
        }
        // Check details
        item.details.forEach((detail) => {
          if (detail.topic.trim() == "" || detail.lesson.trim() == "") {
            state = false;
          }
        });
      });
      return state;
    },
    async save() {
      this.checkCls();
      this.checkSec();
      this.checkSubject();
      if (
        this.checkCls() == false ||
        this.checkSec() == false ||
        this.checkSubject() == false
      ) {
        this.$bvToast.toast(this.$t("Enter the details correctly!"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } else if (this.CheckValues() == false) {
        this.$bvToast.toast("Please enter planner details correctly!", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } else {
        // Prepare data according to the new payload structure
        let formattedPlannerData = this.plannerData.map((item) => {
          // Update data object with common fields
          let dataObj = {
            id: item.data.id,
            plannerGridID: this.myObj.id,
            topicID: item.data.topicID,
            subtopicID: item.data.subtopicID,
            duration: item.data.duration,
            campusID: this.$store.state.userData.cId,
          };

          // Update details with the same common fields
          let detailsArray = item.details.map((detail) => ({
            id: detail.id,
            plannerGridID: this.myObj.id,
            topicID: item.data.topicID,
            subtopicID: item.data.subtopicID,
            duration: item.data.duration,
            dateFrom: item.data.dateFrom,
            dateTo: item.data.dateTo,
            topic: detail.topic,
            materials: detail.materials,
            objectives: detail.objectives,
            lesson: detail.lesson,
            remarks: detail.remarks,
            campusID: this.$store.state.userData.cId,
          }));

          return {
            data: dataObj,
            details: detailsArray,
          };
        });

        let saveObj = {
          plannerGrid: {
            id: this.myObj.id,
            tID: 0,
            clsID: this.myObj.clsID,
            secID: this.secIDs,
            subjectID: this.myObj.subjectID,
            campusID: this.$store.state.userData.cId,
          },
          plannerData: formattedPlannerData,
        };

        console.log("Save Object:", saveObj);

        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "PlannerData/Save?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: saveObj,
          message: "Planner saved successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.$router.push("/manage-planner");
        }
      }
    },

    async LoadInitialData() {
      // Load all classes with sections
      let obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      let classesData = await this.get(obj);
      this.classes = classesData.map((el) => el.cls);
      this.allClassesData = classesData; // Store complete data for sections

      // Load subjects directly
      await this.loadSubjects();

      if (this.$route.params.id > 0) {
        // Load planner grid details for editing
        await this.loadPlannerGrid();
        if (this.myObj.clsID > 0) {
          this.FillSections("filled");
        }
      }
    },

    async loadPlannerGrid() {
      let obj = {
        url:
          this.$store.state.domain +
          "PlannerGrid/GetById?db=" +
          this.$store.state.userData.db +
          "&id=" +
          this.myObj.id,
        token: this.$store.state.userData.token,
      };
      let gridData = await this.get(obj);
      if (gridData) {
        this.myObj.clsID = gridData.clsID;
        this.myObj.subjectID = gridData.subjectID;
        this.secIDs = gridData.secID;
      }
    },
    async LoadData() {
      this.dataLoading = true;
      let obj = {
        url:
          this.$store.state.domain +
          "PlannerData/LoadData?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&gridID=" +
          this.$route.params.id +
          "&clsID=" +
          this.myObj.clsID +
          "&secID=" +
          this.secIDs +
          "&subID=" +
          this.myObj.subjectID,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      console.log(res);
      if (res.length > 0) {
        this.convertToPlannerData(res);
        // await this.loadTopics();
        // Load subtopics for existing data
        for (let item of this.plannerData) {
          if (item.data.topicID) {
            await this.fillSubtopics(item.data);
          }
        }
      } else {
        // await this.loadTopics();
      }
      // console.log(this.collapseData);

      this.dataLoading = false;
    },

    addDetailEntry(item, ind) {
      item.details.push({
        id: 0,
        plannerGridID: item.data.plannerGridID,
        topicID: item.data.topicID,
        subtopicID: item.data.subtopicID,
        duration: item.data.duration,
        dateFrom: item.data.dateFrom,
        dateTo: item.data.dateTo,
        topic: "",
        materials: "",
        objectives: "",
        lesson: "",
        remarks: "",
        campusID: this.$store.state.userData.cId,
      });
    },
    removeDetailEntry(item, detailInd) {
      if (item.details.length > 1) {
        item.details.splice(detailInd, 1);
      }
    },
    async fillSubtopics(data) {
      if (data.topicID) {
        let obj = {
          url:
            this.$store.state.domain +
            "Subtopics/GetByTopic?db=" +
            this.$store.state.userData.db +
            "&topicID=" +
            data.topicID,
          token: this.$store.state.userData.token,
        };
        data.subtopics = await this.get(obj);
        data.subtopicID = 0;
      }
    },
    AddPlannerEntry() {
      this.collapseData.push({ state: true });
      this.plannerData.push({
        data: {
          id: 0,
          plannerGridID: 0,
          topicID: 0,
          subtopicID: 0,
          duration: "",
          dateFrom: null,
          dateTo: null,
          range: "",
          subtopics: [],
          campusID: this.$store.state.userData.cId,
        },
        details: [
          {
            id: 0,
            plannerGridID: 0,
            topicID: 0,
            subtopicID: 0,
            duration: "",
            dateFrom: null,
            dateTo: null,
            topic: "",
            materials: "",
            objectives: "",
            lesson: "",
            remarks: "",
            campusID: this.$store.state.userData.cId,
          },
        ],
      });
    },
    async removePlannerEntry(ind) {
      let item = this.plannerData[ind];
      let hasExistingData = item.details.some((detail) => detail.id > 0);

      if (hasExistingData) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: "This will delete all related planner data!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes, Delete it!"),
        });

        if (result.isConfirmed) {
          // Delete from backend if needed
          this.collapseData.splice(ind, 1);
          this.plannerData.splice(ind, 1);
        }
      } else {
        this.collapseData.splice(ind, 1);
        this.plannerData.splice(ind, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.quill-editor ::v-deep {
  > .ql-container {
    height: 200px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
